export const tagTransfersReport = {
	title: "Card Links",
	descriptionPlace: "List of all card link transfers for the period.",
	descriptionEvent: "List of all event link transfers.",
	filters: {
		zigCodePlaceholder: "Filter by Zig Code",
		zigCodeInvalid: "Invalid Zig Code",
		documentPlaceholder: "Filter by customer document",
		employeePlaceholder: "Filter by employee",
	},
	table: {
		date: "Date and time",
		zigCode: "Zig Code",
		oldUserDocument: "Previous document",
		oldUser: "Previous customer",
		oldUserTooltip:
			"Last customer registered on the card. If the card was reused without being unlinked, the displayed data may not belong to a customer currently attending the event or location/organization",
		newUserDocument: "New document",
		newUser: "New customer",
		employeeName: "Operator",
		eventName: "Event",
		openAccountFromLastUser:
			"This action overwrote the previous customer's open account.",
	},
};
